module.exports = __webpack_public_path__ + "static/client-polda-kaltara-459bf005c89b456e4a1443122f1121da.png";